<div class="container pb-5 page-checkout-form">
  <div *ngIf="!isCheckoutJob" class="row">
    <div class="col-md-12">
      <div class="form-check">
        <input type="checkbox" class="form-check-input mt-2" name="prolong-ad" id="prolong-ad" [(ngModel)]="isProlongAd">
        <label class="ml-2" for="prolong-ad"><span>{{ 'checkout.prolongAd' | translate}} {{expiry_date | date:'fullDate'}}{{ 'checkout.prolongPrice' | translate}}</span></label>
      </div>
      <div *ngIf="errorsCheckout.is_prolong_ad" class="help-block msg-error">
        <p *ngFor="let error of errorsCheckout.is_prolong_ad">{{ error | translate }}</p>
      </div>
    </div>
  </div>
  <h2 class="checkout-title font-weight-bold mt-5 mb-4">{{ 'checkout.title' | translate }}</h2>
  <div *ngIf="isCheckoutJob" class="row">
    <div class="col-12">
      <label>{{ 'checkout.checkoutMethod' | translate}}</label><span class="ml-2 label-mandatory">(&#42;)</span>
      <div class="row">
        <div class="form-group col-12 mb-0">
          <label for="offer" class="radio-inline">
            <input type="radio"
                   id="offer"
                   name="payment"
                   value="Introductory offer"
                   [(ngModel)]="invoice.payment_method"
                   (ngModelChange)="errorsCheckout.payment_method = null"
            />
            <span class="ml-3">{{ 'checkout.introductoryOffer' | translate}}</span>
          </label>
        </div>
        <div class="form-group col-12 mb-0">
          <label for="feedback" class="radio-inline">
            <input type="radio"
                   id="feedback"
                   name="payment"
                   value="Feedback"
                   [(ngModel)]="invoice.payment_method"
                   (ngModelChange)="errorsCheckout.payment_method = null"
            />
            <span class="ml-3">{{ 'checkout.freeFeedback' | translate}}</span>
          </label>
        </div>
      </div>
      <div *ngIf="errorsCheckout.payment_method" class="help-block msg-error">
        <p *ngFor="let error of errorsCheckout.payment_method">{{ error | translate }}</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12">
      <label>{{ 'checkout.invoiceMethod' | translate}}</label><span *ngIf="invoice.payment_method === 'Introductory offer'" class="ml-2 label-mandatory">(&#42;)</span>
      <div class="row">
        <div class="form-group col-12 mb-0">
          <label class="checkbox-inline">
            <input type="checkbox"
                   name="sendEmail"
                   value="1"
                   [checked]="arrSendInvoiceMethod.indexOf(1) !== -1"
                   (change)="checkSendInvoiceMethod(1); errorsCheckout.send_invoice_method = null"
                   [disabled]="invoice.payment_method === 'Feedback'"
            >
            <span class="ml-3" [ngClass]="{'disabled-check': invoice.payment_method === 'Feedback'}">{{ 'checkout.emailOption' | translate}}</span>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12 mb-0">
          <label class="checkbox-inline">
            <input type="checkbox"
                   name="sendPaperMail"
                   value="2"
                   [checked]="arrSendInvoiceMethod.indexOf(2) !== -1"
                   (change)="checkSendInvoiceMethod(2); errorsCheckout.send_invoice_method = null"
                   [disabled]="invoice.payment_method === 'Feedback'"
            >
            <span class="ml-3" [ngClass]="{'disabled-check': invoice.payment_method === 'Feedback'}">{{ 'checkout.paperMailOption' | translate}}</span>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12 mb-0">
          <label class="checkbox-inline">
            <input type="checkbox"
                   name="sendPaperMail"
                   value="3"
                   [checked]="arrSendInvoiceMethod.indexOf(3) !== -1"
                   (change)="checkSendInvoiceMethod(3); errorsCheckout.send_invoice_method = null"
                   [disabled]="invoice.payment_method === 'Feedback'"
            >
            <span class="ml-3" [ngClass]="{'disabled-check': invoice.payment_method === 'Feedback'}">{{ 'checkout.eInvoiceOption' | translate}}</span>
          </label>
        </div>
      </div>
      <div *ngIf="invoice.payment_method !== 'Feedback'">
        <div *ngIf="errorsCheckout.send_invoice_method" class="help-block msg-error">
          <p *ngFor="let error of errorsCheckout.send_invoice_method">
            <span *ngIf="error === 'The send invoice method field is required.'">
              {{'checkout.validation.sendInvoiceMethod'|translate}}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-6">
      <label for="referenceInvoice">{{ 'checkout.invoiceReference' | translate}}</label>
      <input type="text"
             class="form-control custom-input"
             id="referenceInvoice"
             name="referenceInvoice"
             [(ngModel)]="invoice.invoice_note"
      >
    </div>
  </div>

  <!--invoice information form-->
  <h2 class="checkout-title mt-5 mb-4 font-weight-bold">{{ 'checkout.invoiceInfo' | translate}}</h2>
  <div *isEmployer class="row mb-3">
    <div class="form-group col-md-6">
      <label for="companyName" class="custom-label">{{ 'create-account.companyName' | translate }}</label><span class="ml-2 label-mandatory">(&#42;)</span>
      <input type="text"
             class="form-control custom-input"
             id="companyName"
             name="companyName"
             placeholder="{{ 'create-account.companyName' | translate }}"
             [(ngModel)]="profile.companyName"
             [ngClass]="{'input-error': errorsUserInfo.companyName}"
             (ngModelChange)="errorsUserInfo.companyName = null"
      >
      <div *ngIf="errorsUserInfo.companyName" class="help-block msg-error">
        <p *ngFor="let error of errorsUserInfo.companyName">{{ error | translate }}</p></div>
    </div>
  </div>
  <div *isEmployer class="row mb-3">
    <div class="form-group col-md-6">
      <label for="companyNum" class="custom-label">{{ 'create-account.companyNum' | translate }}</label><span class="ml-2 label-mandatory">(&#42;)</span>
      <input type="text"
             class="form-control custom-input"
             id="companyNum"
             appCompanyNumFormat
             name="companyNum"
             maxlength="11"
             placeholder="{{ 'create-account.companyNum' | translate }}"
             [(ngModel)]="profile.companyNum"
             [ngClass]="{'input-error': errorsUserInfo.companyNum}"
             (ngModelChange)="errorsUserInfo.companyNum = null"
      >
      <div *ngIf="errorsUserInfo.companyNum" class="help-block msg-error">
        <p *ngFor="let error of errorsUserInfo.companyNum">{{ error | translate }}</p></div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="form-group col-md-3">
      <label for="firstName" class="custom-label">{{ 'contact.form.firstName' | translate }}</label><span class="ml-2 label-mandatory">(&#42;)</span>
      <input type="text"
             class="form-control custom-input"
             id="firstName"
             name="firstName"
             placeholder="{{ 'contact.form.firstName' | translate }}"
             [(ngModel)]="profile.firstName"
             [ngClass]="{'input-error': errorsUserInfo.firstName}"
             (ngModelChange)="errorsUserInfo.firstName = null"
      >
      <div *ngIf="errorsUserInfo.firstName" class="help-block msg-error">
        <p *ngFor="let error of errorsUserInfo.firstName">{{ error | translate }}</p>
      </div>
    </div>
    <div class="form-group col-md-3">
      <label for="lastName" class="custom-label">{{ 'contact.form.lastName' | translate }}</label><span class="ml-2 label-mandatory">(&#42;)</span>
      <input type="text"
             class="form-control custom-input"
             id="lastName"
             name="lastName"
             placeholder="{{ 'contact.form.lastName' | translate }}"
             [(ngModel)]="profile.lastName"
             [ngClass]="{'input-error': errorsUserInfo.lastName}"
             (ngModelChange)="errorsUserInfo.lastName = null"
      >
      <div *ngIf="errorsUserInfo.lastName" class="help-block msg-error">
        <p *ngFor="let error of errorsUserInfo.lastName">{{ error | translate }}</p>
      </div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="form-group col-md-6">
      <label for="address" class="custom-label">{{ 'create-account.address' | translate }}</label><span class="ml-2 label-mandatory">(&#42;)</span>
      <input type="text"
             class="form-control custom-input"
             id="address"
             name="address"
             placeholder="{{ 'create-account.address' | translate }}"
             [(ngModel)]="profile.address"
             [ngClass]="{'input-error': errorsUserInfo.address}"
             (ngModelChange)="errorsUserInfo.address = null"
      >
      <div *ngIf="errorsUserInfo.address" class="help-block msg-error">
        <p *ngFor="let error of errorsUserInfo.address">{{ error | translate }}</p>
      </div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="form-group col-md-6">
      <label class="custom-label">{{ 'recruit.form.country' | translate }}</label>
      <ng-select class="custom-ng-select" *ngIf="countries && countries.length > 0" [items]="countries" bindLabel="name" bindValue="name" [(ngModel)]="profile.country" [ngClass]="{'input-error': errors.country}"
                 placeholder="{{ 'recruit.form.country' | translate }}">
      </ng-select>
    </div>
  </div>
  <div class="row mb-3">
    <div class="form-group col-md-6">
      <label for="invoiceCity" class="custom-label">{{ 'recruit.form.city' | translate }}</label><span class="ml-2 label-mandatory">(&#42;)</span>
      <input type="text"
             id="invoiceCity"
             name="city"
             class="form-control custom-input"
             placeholder="{{ 'recruit.form.city' | translate }}"
             [(ngModel)]="profile.city"
             [ngClass]="{'input-error': errorsUserInfo.city}"
             (ngModelChange)="errorsUserInfo.city = null"
      >
      <div *ngIf="errorsUserInfo.city" class="help-block msg-error">
        <p *ngFor="let error of errorsUserInfo.city">{{ error | translate }}</p>
      </div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="form-group col-md-6">
      <label for="postCode" class="custom-label">{{ 'create-account.postCode' | translate }}</label><span class="ml-2 label-mandatory">(&#42;)</span>
      <input type="text"
             class="form-control custom-input"
             id="postCode"
             name="postCode"
             placeholder="{{ 'create-account.postCode' | translate }}"
             [(ngModel)]="profile.postCode"
             [ngClass]="{'input-error': errorsUserInfo.postCode}"
             (ngModelChange)="errorsUserInfo.postCode = null"
      >
      <div *ngIf="errorsUserInfo.postCode" class="help-block msg-error">
        <p *ngFor="let error of errorsUserInfo.postCode">{{ error | translate }}</p>
      </div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="form-group col-md-6">
      <label for="email" class="custom-label">{{ 'contact.form.email' | translate }}</label>
      <input type="email"
             class="form-control custom-input"
             id="email"
             name="email"
             disabled
             [(ngModel)]="userProfile!.email"
      >
    </div>
  </div>
  <div class="row mb-3">
    <div class="form-group col-md-6">
      <label for="phoneNumber1" class="custom-label">{{ 'contact.form.phone1' | translate }}</label><span class="ml-2 label-mandatory">(&#42;)</span>
      <input type="tel"
             class="form-control custom-input"
             id="phoneNumber1"
             name="phoneNumber1"
             placeholder="{{ 'contact.form.phone1' | translate }}"
             [(ngModel)]="profile.phoneNumber1"
             [ngClass]="{'input-error': errorsUserInfo.phoneNumber1}"
             (ngModelChange)="errorsUserInfo.phoneNumber1 = null"
      >
      <div *ngIf="errorsUserInfo.phoneNumber1" class="help-block msg-error">
        <p *ngFor="let error of errorsUserInfo.phoneNumber1">{{ error | translate }}</p>
      </div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="form-group col-md-6">
      <label for="phoneNumber2" class="custom-label">{{ 'contact.form.phone2' | translate }}</label>
      <input type="tel"
             class="form-control custom-input"
             id="phoneNumber2"
             name="phoneNumber2"
             placeholder="{{ 'contact.form.phone2' | translate }}"
             [(ngModel)]="profile.phoneNumber2"
      >
    </div>
  </div>
  <div class="row mb-3">
    <div class="form-group col-md-6">
      <label class="custom-label">{{'language' | translate}}</label>
      <div class="input-style-father position-relative">
        <select class="form-control input-style-dropdown custom-input" name="language" [(ngModel)]="profile.language">
          <option value="en">{{'english' | translate}}</option>
          <option value="sv">{{'swedish' | translate}}</option>
        </select>
      </div>
    </div>
  </div>
  <!--specific invoice email-->
  <div class="row">
    <div class="form-group col-12">
      <label class="checkbox-inline" style="margin-top: -2px;">
        <input type="checkbox"
               name="agree"
               (change)="toggleSpecificEmail($event)"
        ><span class="ml-3">{{'checkout.specificInvoiceEmail' | translate}}</span></label>
    </div>
  </div>
  <div class="row mt-4 mb-3">
    <div class="form-group col-md-6">
      <label for="invoiceEmail">{{ 'checkout.invoiceEmail' | translate }}</label>
      <input type="email"
             class="form-control custom-input"
             id="invoiceEmail"
             name="invoiceEmail"
             [ngClass]="{'input-error': errorsCheckout.invoice_email}"
             placeholder="{{ 'checkout.invoiceEmail' | translate }}"
             [(ngModel)]="specificEmail"
             [disabled]="!specificEmailEnable"
      >
      <div *ngIf="errorsCheckout.invoice_email" class="help-block msg-error">
        <p *ngFor="let error of errorsCheckout.invoice_email">{{ error | translate }}</p>
      </div>
    </div>
  </div>
  <div class="row mb-3 mt-4">
    <div class="col-md-8">
      <hr style="opacity: 0.6; border: 1px solid #0C2D54;">
    </div>
  </div>
  <div *ngIf="isCheckoutJob" class="row">
    <div class="col-lg-12">
      <div class="jumbotron text-center">
        <h2 class="text-center"><strong>{{'checkout.GDPR' | translate}}</strong></h2>
        <div [innerHTML]=" 'checkout.introGDPR' | translate"></div>
      </div>
      <div [innerHTML]=" 'checkout.interestGDPR' | translate"></div>
      <p><a href="{{downloadGDPR}}" class="link-download">{{'checkout.downloadTemplate' | translate}}</a></p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-8">
      <p>{{'checkout.preview' | translate}}<a style="color: #17A2B8"
                                              [routerLink]="['/create-account', 'terms-and-conditions']" target="_blank"> {{'create-account.term' |
        translate}}</a>{{'checkout.termContent' | translate}}</p>
    </div>
  </div>
  <br>
  <div *ngIf="isCheckoutJob" class="row">
      <div class="col-lg-8">
          <button class="btn btn-accept-prolong mr-1" type="button" (click)="updateProfile()">{{'checkout.accept' | translate }}</button>
          <button class="btn back-account ml-1" type="button" (click)="back()">{{'checkout.goBack' | translate }}</button>
      </div>
  </div>
  <div *ngIf="!isCheckoutJob" class="row">
    <div class="col-lg-8">
      <button class="btn btn-accept-prolong mr-3" type="button" (click)="updateProlongAd()">{{'checkout.acceptProlong' | translate }}</button>
      <button [routerLink]="['/my-account']" [queryParams]="{tab: 'published'}" class="btn back-account" type="button">{{'checkout.backAccount' | translate }}</button>
    </div>
  </div>
</div>
